export default {
  namespaced: true,
  state: {
    urlParams: null
  },
  getters: {
    user_id: state => state.urlParams && state.urlParams.user_id,
    system: state => state.urlParams && state.urlParams.system,
    app_token: state => state.urlParams && state.urlParams.app_token,
    urlParams: state => state.urlParams
  },
  mutations: {
    URLPARAMS (state, data) {
      state.urlParams = data
    }
  },
  actions: {
    setUrlParams ({ commit }, urlParams) {
      commit('URLPARAMS', urlParams)
    }
  }
}
